export const faqsEstacio = [
    {
        pergunta: 'O que é o Clube do Aluno?',
        resposta: 'O Clube do Aluno é um Clube de Benefícios exclusivo para alunos, que oferece cupons, ofertas e cashback em grandes lojas nacionais e internacionais, proporcionando economia real e vantagens no dia a dia.',
    },
    {
        pergunta: 'Quem pode acessar o Clube do Aluno?',
        resposta: 'O Clube do Aluno é destinado a alunos que atendam aos critérios de elegibilidade definidos pela instituição parceira.',
    },
    {
        pergunta: 'É necessário pagar para utilizar o Clube do Aluno?',
        resposta: 'Não. O acesso ao Clube do Aluno é gratuito para os alunos elegíveis.',
    },
    {
        pergunta: 'Como verificar se uma loja possui descontos no Clube do Aluno?',
        resposta: 'É possível realizar a busca pelo nome da loja ou navegar pelas categorias disponíveis na plataforma.',
    },
    {
        pergunta: 'Quais tipos de descontos o Clube do Aluno oferece?',
        resposta: 'O Clube do Aluno disponibiliza três formas de economia: cupons, ofertas e cashback.',
    },
    {
        pergunta: 'O que é um cupom?',
        resposta: 'Cupom é um código de desconto disponibilizado por lojas parceiras que, quando utilizado conforme as regras informadas, concede redução no valor final da compra.',
    },
    {
        pergunta: 'Como utilizar um cupom?',
        resposta: 'Selecione a loja e o cupom desejado no Clube do Aluno, copie o código ou clique no link cuponado e insira o código no campo destinado a cupons no carrinho da loja. Em alguns casos, o desconto é aplicado automaticamente.',
    },
    {
        pergunta: 'Não encontro onde usar o código do cupom. O que fazer?',
        resposta: 'Cada loja possui um layout próprio. Procure por campos como "Cupom", "Cupom de desconto", "Vale", "Cheque Eletrônico" ou similares. Em ofertas sem código, o desconto já estará aplicado no carrinho.',
    },
    {
        pergunta: 'Meu cupom não funcionou. O que devo fazer?',
        resposta: 'Verifique se o cupom está dentro do prazo de validade, se as regras foram atendidas e se o desconto é aplicado apenas no carrinho ou na etapa final da compra. Caso o problema persista, entre em contato pelo e-mail suporte@meucupom.com.',
    },
    {
        pergunta: 'Posso utilizar o mesmo cupom mais de uma vez?',
        resposta: 'Essa regra varia de acordo com cada loja parceira. Alguns cupons podem ser utilizados apenas uma vez por CPF ou são válidos exclusivamente para a primeira compra. As condições estão descritas no próprio cupom.',
    },
    {
        pergunta: 'Qual a diferença entre cupom e oferta?',
        resposta: 'Cupom é um desconto concedido por meio de código ou link exclusivo. Oferta é uma promoção já existente no site da loja parceira, organizada para facilitar a visualização.',
    },
    {
        pergunta: 'Como utilizar uma oferta?',
        resposta: 'Ao clicar na oferta, o usuário será direcionado automaticamente para o site da loja parceira, já com os preços promocionais aplicados.',
    },
    {
        pergunta: 'Qual a diferença entre oferta e oferta de produto?',
        resposta: 'Oferta reúne diversos produtos em promoção. Oferta de produto refere-se a um desconto aplicado a um item específico.',
    },
    {
        pergunta: 'Os descontos possuem validade?',
        resposta: 'Sim. Cada cupom ou oferta possui um prazo de validade definido, que pode variar conforme a campanha do parceiro.',
    },
    {
        pergunta: 'Como saber se o desconto é válido?',
        resposta: 'Todos os descontos passam por curadoria. Nos cupons, o desconto é visualizado após a aplicação do código. Nas ofertas, o preço já é apresentado com redução no site da loja parceira.',
    },
    {
        pergunta: 'As lojas parceiras são confiáveis?',
        resposta: 'Sim. O Clube do Aluno trabalha com varejistas reconhecidos no mercado. Recomenda-se também consultar a reputação das lojas em plataformas de avaliação.',
    },
    {
        pergunta: 'O que é cashback?',
        resposta: 'Cashback é a devolução de parte do valor gasto em compras realizadas nas lojas parceiras do Clube do Aluno.',
    },
    {
        pergunta: 'Como resgatar o cashback?',
        resposta: 'Realize o login no Clube do Aluno, efetue a compra por meio de uma loja parceira, cadastre sua chave Pix no perfil do usuário e aguarde a validação da compra.',
    },
    {
        pergunta: 'Em quanto tempo o cashback é liberado?',
        resposta: 'O prazo de liberação varia de acordo com a política de validação de cada loja parceira.',
    },
    {
        pergunta: 'O cashback pode ser cancelado?',
        resposta: 'Sim. Em casos de cancelamento, devolução ou troca do pedido, o cashback será automaticamente invalidado.',
    },
    {
        pergunta: 'É possível acessar o Clube do Aluno pelo celular?',
        resposta: 'Sim. A plataforma pode ser acessada tanto por dispositivos móveis quanto por computadores.',
    },
    {
        pergunta: 'Esqueci minha senha. O que devo fazer?',
        resposta: 'Recomenda-se realizar a redefinição de senha pelos canais oficiais disponibilizados pela instituição responsável.',
    },
    {
        pergunta: 'Como entrar em contato com o suporte?',
        resposta: 'Para dúvidas ou suporte, entre em contato pelo e-mail suporte@meucupom.com.',
    },
]
